import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { authStateAtom, redirectToAuthEvent } from '@root/entities/auth'
import { useTranslation } from '@root/shared/localization'

import type { ClassNameProps } from '@root/shared/react'

type SellButtonProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  children: React.ReactNode
  disabled?: boolean
} & ClassNameProps

// TODO: move to ui kit?
export const SellButton: React.FC<SellButtonProps> = ({
  className,
  onClick,
  children,
  disabled,
}) => {
  const { t } = useTranslation()
  const [isLoggedIn] = useAtom(authStateAtom.isLoggedIn)
  const redirectToAuth = useAction(redirectToAuthEvent)

  const renderButtonContent = () => {
    if (!isLoggedIn) {
      return <>{t('auth.login')}</>
    }

    return children
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (!isLoggedIn) {
      redirectToAuth()
      return
    }

    onClick(e)
  }

  return (
    <Root className={className} onClick={handleClick} disabled={disabled}>
      {renderButtonContent()}
    </Root>
  )
}

const Root = styled.button`
  pointer-events: auto;
  outline: none;
  border: 1px solid var(--downA-5);
  background: var(--downA-2);
  color: var(--down-9);
  cursor: pointer;

  padding: 6px;
  text-transform: uppercase;
  border-radius: 6px;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  gap: 6px;

  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  transition: background 0.2s ease-in-out;

  &:hover {
    background: var(--downA-3);
  }

  &:has(svg) {
    padding-inline: 10px;
  }

  &:disabled {
    background: transparent;
    border-color: var(--background-4);
    color: var(--text-7);
  }
`
